import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { useView } from './useView';
import { Step } from 'signup-constants/Step';
import { Data } from 'signup-constants/signupData/Data';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompanyNameView = () => {
  const stepKey = Step.CompanyName;
  const dataKey = Data.CompanyName;
  const {
    submit
  } = useView({
    stepKey
  });
  const stepConfig = getStepConfig(stepKey);
  if (!stepConfig) {
    return null;
  }
  return /*#__PURE__*/_jsx(BaseView, {
    children: /*#__PURE__*/_jsx(SignupDataInputForm, {
      dataKey: dataKey,
      inputMode: 'text',
      submit: submit
    }, dataKey)
  });
};